import React from 'react'
import Header from '../Layout/Header'

function TotalMember() {
  return (
    <div >
        <Header/>
        <div className='total_m'>

        <div class="container   pptt">
       
        <div class="d-flex align-items-center">
            <button class="btn btn-light border-0">&#x2190;</button>
            <input type="date" class="form-control ms-2" style={{maxWidth: '200px'}}/>
        </div>
        
        <div class="d-flex justify-content-between filter-buttons mt-2">
            <button class="active">All</button>
            <button>Today</button>
            <button>Yesterday</button>
            <button>Week</button>
        </div>
        
        <div class="row mt-3">
            <div class="col-6 p-2">
                <div class="member-box">    
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Total Registered Member</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Total Valid Member</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Member A</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Valid A</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Member B</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Valid B</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Member C</p>
                </div>
            </div>
            <div class="col-6 p-2">
                <div class="member-box">
                    <p class="mb-1 fw-bold">0</p>
                    <p class="small">Valid C</p>
                </div>
            </div>
        </div>
    </div>
        </div>

    </div>
  )
}

export default TotalMember